import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/phone_icon.png'
import _imports_1 from '@/assets/img/pwd_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-f208aad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "welcome" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content1" }, "Hi,你好！"),
  /*#__PURE__*/_createElementVNode("div", { class: "content2" }, "欢迎进入智学慧育平台"),
  /*#__PURE__*/_createElementVNode("div", { class: "content3" }, "Welcome to Wisdom Education Platform")
], -1))
const _hoisted_3 = { class: "loginBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "进入智学慧育平台", -1))
const _hoisted_5 = { class: "loginForm" }
const _hoisted_6 = { class: "formItem" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "formItem" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "loginBtnDiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resetPassword = _resolveComponent("resetPassword")!

  return (!_ctx.userKey)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                placeholder: "请输入手机号码",
                maxlength: 11,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.mobile) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.loginForm.mobile,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                placeholder: "请输入密码",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.loginForm.password,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "loginBtn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
            }, " 登录 "),
            _createElementVNode("div", {
              class: "forgetBtn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openResetDialog && _ctx.openResetDialog(...args)))
            }, " 忘记密码? ")
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_resetPassword, {
              onCloseDialog: _ctx.closeResetDialog,
              isShow: _ctx.isShowReset
            }, null, 8, ["onCloseDialog", "isShow"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}